export const PRIVACY_POLICY_LAST_UPDATED = "20 de agosto de 2026";
export const PRIVACY_POLICY_VERSION = "v1.1";

export const TERMS_LAST_UPDATED = "16 de agosto de 2026";

export const PRIVACY_POLICY_VERSION_LABEL = `Última actualización: ${PRIVACY_POLICY_LAST_UPDATED}`;

export const TERMS_VERSION_LABEL = `Última actualización: ${TERMS_LAST_UPDATED}`;

export const MIN_AGE_REQUIRED = 14;

export const AGE_DECLARATION_VERSION = "v1.0";

export const UNDERAGE_REJECTION_MESSAGE =
  "Para crear una cuenta en Comuni Home es necesario tener 14 años o más, conforme al artículo 7 de la Ley Orgánica 3/2018 de Protección de Datos Personales. Si convives en una vivienda registrada, la persona titular puede gestionar por ti las reservas y las comunicaciones con la comunidad.";

export const UNDERAGE_ACCOUNT_INACTIVE_MESSAGE =
  "Tu cuenta ha quedado inactiva porque has declarado tener menos de 14 años. Si convives en una vivienda registrada, la persona titular puede gestionar por ti las reservas y las comunicaciones con la comunidad.";

export const INVITE_UNDERAGE_WARNING =
  "No se permite invitar a menores de 14 años (art. 7 LOPDGDD). Si convives con un menor de 14 años en la vivienda, como titular puedes gestionar por él las reservas y las comunicaciones con la comunidad.";
